import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 200px;
  padding: 30px;
  overflow: hidden;
`;
